import { render } from "./PrimerPost.vue?vue&type=template&id=5e439e1e"
import script from "./PrimerPost.vue?vue&type=script&lang=js"
export * from "./PrimerPost.vue?vue&type=script&lang=js"

import "../../assets/styles/post.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__